export default __webpack_public_path__ + "static/glu-video-paceholder-f09eda7dec751f077947a9bc15be3c08.svg";